import { observable } from "mobx";

export default class ExemptionRegistrationResponse {
  @observable
  licensePlate: string;
}
